export enum NoPayoutReason {
    aborted = 'aborted',
    ledgerNumber = 'ledgerNumber',
    markedAsUnpaid = 'markedAsUnpaid',
    missingAmount = 'missingAmount',
    NoActiveEmployment = 'NoActiveEmployment',
    noEmailAddress = 'noEmailAddress',
    payoutByTxcs = 'payoutByTxcs',
    providerName = 'providerName',
    providerOrganization = 'providerOrganization',
    relationNumber = 'relationNumber',
    waitingForConsultOrGrading = 'waitingForConsultOrGrading',
    waitingForFollowUpActivity = 'waitingForFollowUpActivity',
    waitingforOsasc2 = 'waitingforOsasc2',
    waitingForReProcessing = 'waitingForReProcessing',
    zeroAmount = 'zeroAmount',
}
